// Utils
import {
  IpsFromEntity,
  IpsFromEvent,
  FullSARFilingResponse,
  SARAttachmentResponse,
  UpdateSarResponse,
  ValidateSarResponse,
  SarNarrativeTemplate,
  ArchiveSarResponse,
  ShortSARFilingResponse,
} from 'app/modules/fincenSAR/responses';
import {
  UpdateSarPayload,
  SarXlsxCsvExportPayload,
  SarSubmitPayload,
  DuplicateSarPayload,
  ArchivePayload,
  ChangeSarQueuePayload,
  EditSarReviewerPayload,
} from 'app/modules/fincenSAR/requests';
import {
  destroy,
  get,
  post,
  put,
  upload,
  downloadFile,
} from 'app/shared/utils/fetchr';
import { FilingNarrativeTemplateType } from 'app/modules/narrativeTemplates/models';

export const updateSar = (
  id: string,
  payload: UpdateSarPayload,
): Promise<UpdateSarResponse> => {
  return put(`/v1/sars/${id}/edit`, payload);
};

export const validateSar = (id: string): Promise<ValidateSarResponse> => {
  return post(`/v1/sars/${id}/validate`);
};

export const ipsFromEntity = (sarId: string): Promise<IpsFromEntity> => {
  return post(`/v1/sars/${sarId}/entities/import-ips`);
};

export const ipsFromEvent = (sarId: string): Promise<IpsFromEvent> => {
  return post(`/v1/sars/${sarId}/events/import-ips`);
};

export const uploadAttachment = (
  id: string,
  file: File,
): Promise<SARAttachmentResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  return upload(`/v1/sars/${id}/attachment`, formData);
};

export const deleteAttachment = (
  id: string,
): Promise<Record<string, never>> => {
  return destroy(`/v1/sars/${id}/attachment`);
};

export const downloadAttachment = (id: number, fileName: string) => {
  return downloadFile(`/v1/attachments/download/${id}`, fileName);
};

export const getNarrativeTemplates = (): Promise<SarNarrativeTemplate[]> => {
  // DEPRECATION (P2-T1): old route `/sars/narrative/list` to be removed after migration.
  return get('/v1/narrative-templates/filings/list', [
    {
      key: 'template_type',
      value: FilingNarrativeTemplateType.FINCEN_SAR,
    },
  ]);
};

export const exportXlsxOrCsv = (
  payload: SarXlsxCsvExportPayload,
): Promise<Record<string, never>> => {
  return post('/v1/sars/single-email-xlsx', payload);
};

export const archiveSar = (
  payload: ArchivePayload,
): Promise<ArchiveSarResponse> => {
  return post('/v1/sars/archive', payload);
};

export const returnToEdit = (
  sarId: number,
): Promise<ShortSARFilingResponse> => {
  return post(`/v1/sars/${sarId}/unlock`);
};

export const readyForReview = (
  sarId: number,
): Promise<ShortSARFilingResponse> => {
  return post(`/v1/sars/${sarId}/lock`);
};

export const submitSar = (
  payload: SarSubmitPayload,
): Promise<FullSARFilingResponse> => {
  return post(`/v1/sars/${payload.id}/submit`, payload);
};

export const duplicateSar = (
  payload: DuplicateSarPayload,
  useCacheEndpoint: boolean = false,
): Promise<FullSARFilingResponse> => {
  if (useCacheEndpoint) {
    return post('/v1/sars/cached/duplicate', payload);
  }
  return post('/v1/sars/duplicate', payload);
};

export const changeSarQueue = (
  payload: ChangeSarQueuePayload,
): Promise<{ filings: ShortSARFilingResponse[] }> => {
  return post('/v1/sars/requeue', payload);
};

export const editSarReviewerApi = (
  id: number,
  payload: EditSarReviewerPayload,
): Promise<ShortSARFilingResponse> => {
  return put(`/v1/sars/${id}/edit`, payload);
};
